import { ErrorHero } from './ErrorHero';

export const NotFoundHero = () => (
  <ErrorHero
    title="Page Not Found"
    subtitle={'Sorry, the page you are looking for does\u00a0not\u00a0exist.'}
  />
);
